import { NotificationsService } from './../../shared/notifications/notifications.service';
import { Injectable } from '@angular/core';
import axios from 'app/api/axios';
import { AxiosResponse } from 'axios';
import { AngularFirestore } from '@angular/fire/firestore';
import { CourierCode, CourierOrder } from 'app/shared/shared.interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CourierOrdersService {
  constructor(private notificationsService: NotificationsService, private firestore: AngularFirestore) {}

  getCourierOrderDetails(courier_order_id: string): Observable<CourierOrder> {
    const docRef = this.firestore.collection<CourierOrder>('courier-orders');
    return docRef.doc(courier_order_id).valueChanges();
  }

  overrideCourierOrderState(courierOrderIds: string[], stateEnum: string, reason: string): void {
    const data = {
      state: stateEnum,
      reason: reason,
      courier_order_ids: courierOrderIds,
    };
    axios({
      method: 'POST',
      url: '/courier-order/override-states',
      data: data,
    })
      .then(() => {
        this.notificationsService.publish({
          type: 'success',
          message: 'Courier Order State Overriden',
        });
      })
      .catch(() =>
        this.notificationsService.publish({
          type: 'error',
          message: 'Could not update courier order state. Please contact support.',
        })
      );
  }

  rehydrateAggregate(courierOrderId: string) {
    axios({
      method: 'POST',
      url: '/firestore/rehydrate-firestore-readmodel/' + courierOrderId,
    })
      .then((res) => {
        return res.data;
      })
      .catch(() =>
        this.notificationsService.publish({
          type: 'error',
          message: 'Error building order - Please contact support. (Error Code:RH-' + courierOrderId + ')',
        })
      );
  }

  recreateCourierOrder(courierOrderId: string): void {
    axios({
      method: 'POST',
      url: '/courier-order/' + courierOrderId + '/create-waybill',
    })
      .then(() => {
        this.notificationsService.publish({
          type: 'success',
          message: 'Successfully Reattempted Courier Order Creation',
        });
      })
      .catch((error) => {
        this.notificationsService.publish({
          type: 'error',
          message: error.response.data.message,
        });
      });
  }

  notify(successful: boolean, message: string): void {
    const notificationType = successful ? 'success' : 'error';
    this.notificationsService.publish({
      type: notificationType,
      message: message,
    });
  }


  getCourierCodes(business_id?: string): Promise<CourierCode[] | void> {
    return axios({
      method: 'POST',
      url: '/generic/cqrs/get-courier-codes',
      data: business_id,
    })
      .then((response: AxiosResponse<CourierCode[]>) => {
        return response.data;
      })
      .catch((error) => {
        this.notificationsService.publish({
          type: 'error',
          message: error.response.data.message,
        });
      });
  }

}
